import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader';

import { updateListingPriority } from '../../../actions/siteadmin/updateListingPriority';

import s from './ListingPrioritiesManagement.css';

class ListingPrioritiesManagement extends React.Component {

  static propTypes = {
    data: PropTypes.object,
    refetch: PropTypes.func.isRequired,
    updateListingPriority: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: '',
      sortOrder: 'ASC',
      editingId: null,
      editingPriority: '',
      typing: false,
      typingTimeout: 0
    };
  }

  paginationData = (currentPage) => {
    const { refetch } = this.props;
    const { searchList, sortOrder } = this.state;
    this.setState({ currentPage });
    refetch({ currentPage, searchList, sortOrder });
  }

  handleClick = (searchList) => {
    const { refetch } = this.props;
    const { sortOrder } = this.state;
    this.setState({ currentPage: 1 });
    refetch({ currentPage: 1, searchList, sortOrder });
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  handleSort = () => {
    const { refetch } = this.props;
    const { searchList, sortOrder } = this.state;
    const newSortOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
    this.setState({ sortOrder: newSortOrder, currentPage: 1 });
    refetch({ currentPage: 1, searchList, sortOrder: newSortOrder });
  }

  handleEditClick = (id, currentPriority) => {
    this.setState({
      editingId: id,
      editingPriority: currentPriority || ''
    });
  }

  handlePriorityChange = (e) => {
    this.setState({ editingPriority: e.target.value });
  }

  handleSavePriority = async (id) => {
    const { updateListingPriority, refetch } = this.props;
    const { editingPriority, currentPage, searchList, sortOrder } = this.state;
    const priority = parseInt(editingPriority, 10) || 0;

    const result = await updateListingPriority(id, priority);
    if (result?.status === 200) {
      this.setState({ editingId: null, editingPriority: '' });
      await refetch({ currentPage, searchList, sortOrder });
    }
  }

  handleCancelEdit = () => {
    this.setState({ editingId: null, editingPriority: '' });
  }

  getSortIcon = () => {
    const { sortOrder } = this.state;
    return sortOrder === 'ASC' ? ' ⬆️' : ' ⬇️';
  }

  thead = () => {
    return [
      { data: 'ID' },
      { data: 'Title' },
      { data: 'Location' },
      {
        data: (
          <span
            onClick={this.handleSort}
            style={{ cursor: 'pointer', userSelect: 'none' }}
          >
            Priority{this.getSortIcon()}
          </span>
        )
      },
      { data: 'Actions' }
    ];
  }

  tbody = () => {
    const { data } = this.props;
    const { editingId, editingPriority } = this.state;

    return data?.results?.map((value, key) => {
      const isEditing = editingId === value.id;
      const location = [value.city, value.state].filter(Boolean).join(', ');

      return {
        id: key,
        data: [
          { data: value.id },
          { data: value.title || '-' },
          { data: location || '-' },
          {
            data: isEditing ? (
              <input
                type="number"
                value={editingPriority}
                onChange={this.handlePriorityChange}
                style={{ width: '80px', padding: '4px 8px' }}
                min="0"
                autoFocus
              />
            ) : (
              <span>{value.priority || '-'}</span>
            )
          },
          {
            data: isEditing ? (
              <div>
                <a
                  href="javascript:void(0)"
                  onClick={() => this.handleSavePriority(value.id)}
                  style={{ marginRight: '10px' }}
                >
                  Save
                </a>
                <a
                  href="javascript:void(0)"
                  onClick={this.handleCancelEdit}
                >
                  Cancel
                </a>
              </div>
            ) : (
              <a
                href="javascript:void(0)"
                onClick={() => this.handleEditClick(value.id, value.priority)}
              >
                Edit
              </a>
            )
          }
        ]
      };
    });
  }

  render() {
    const { data } = this.props;
    const { currentPage } = this.state;
    const loading = !data;

    return (
      <div>
        {loading && <div><Loader type={"text"} /></div>}

        {!loading && <div>
          <CommonTable
            title="Listing Priorities"
            thead={this.thead}
            tbody={this.tbody}
            isSearch
            handleSearch={(e) => this.handleSearchChange(e)}
          />
          <div>
            {
              data?.results?.length > 0 && <div>
                <CustomPagination
                  total={data.count}
                  currentPage={currentPage}
                  defaultCurrent={1}
                  defaultPageSize={10}
                  change={this.paginationData}
                  paginationLabel="Listings"
                  isScroll
                />
              </div>
            }
          </div>
        </div>}
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  updateListingPriority
};

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch)
)(ListingPrioritiesManagement);
